<div class="preview">
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="preview-header">
        <div class="preview-header__left">
          <pdq-heading element="h5">Preview</pdq-heading>
          @if (themeEditorUrl) {
            <pdq-link
              size="small"
              label="Preview In Shopify"
              [clickable]="true"
              [external]="true"
              [url]="themeEditorUrl"></pdq-link>
          }
        </div>
        @if (showDeviceToggle) {
          <div class="preview-header__right">
            <div class="device-switch">
              <button (click)="mode.set('desktop')" [class.active]="mode() === 'desktop'">Desktop</button>
              <button (click)="mode.set('mobile')" [class.active]="mode() === 'mobile'">Mobile</button>
            </div>
          </div>
        }
      </div>
      <pdq-divider></pdq-divider>

      @if (zipCodeAvailableControl) {
        <div class="card__header">
          <pdq-checkbox label="Customer zip code available" [formControl]="zipCodeAvailableControl"></pdq-checkbox>
        </div>
      }
      @if (config?.pluginType === PluginType.PRO_SERVICE && variantAvailabilityControl) {
        <div>
          <pdq-radio-group label="Item availability" [formControl]="variantAvailabilityControl">
            <pdq-radio-button
              [checked]="variantAvailabilityControl.value === 'inStock'"
              [value]="'inStock'"
              text="In stock"></pdq-radio-button>
            <pdq-radio-button
              [checked]="variantAvailabilityControl === 'partial'"
              [value]="'partiallyInStock'"
              text="Partially in stock"></pdq-radio-button>
            <pdq-radio-button
              [checked]="variantAvailabilityControl === 'outOfStock'"
              [value]="'outOfStock'"
              text="Out of stock"></pdq-radio-button>
          </pdq-radio-group>
        </div>
        <pdq-divider></pdq-divider>
      }

      @if (mode() === 'mobile') {
        <div class="mobile-frame-wrapper">
          <mobile-frame [scrollable]="true" [height]="600">
            <ng-template [ngTemplateOutlet]="productMockTpl"></ng-template>
          </mobile-frame>
        </div>
      } @else {
        <ng-template [ngTemplateOutlet]="productMockTpl"></ng-template>
      }
    </div>
  </pdq-card>
  <p class="subdued">
    Tip: Place the widget below the "Add to cart" button for best results. You can also place it anywhere else on the
    product page.
  </p>
</div>

<ng-template #productMockTpl>
  <div class="preview__product" [class.preview__product--mobile]="mode() === 'mobile'">
    <div class="preview__product__image"></div>
    <div class="preview__product__info">
      <div class="preview__product__title-row">
        <p class="preview__product__name">Product name</p>
        <p class="preview__product__price">$15.36</p>
      </div>
      <div class="preview__product__button">Add to Cart</div>
      <div class="preview__product__app">
        <div
          class="container"
          [ngStyle]="
            config?.layoutMode === LayoutMode.BASIC
              ? {
                  'background-color': config?.design?.backgroundColor,
                  color: config?.design?.fontColor,
                  padding: config?.design?.padding + 'px',
                  'border-radius': config?.design?.cornerRadius + 'px',
                }
              : null
          ">
          <div class="content">
            <ng-container *ngTemplateOutlet="bodyTemplate ?? null"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
